import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private loader = new BehaviorSubject<boolean>(false);
  loading$ = this.loader.asObservable();

  public showLoader(): void {
    this.loader.next(true);
  }

  public hideLoader(): void {
    this.loader.next(false);
  }

  public get spinnerStatus(): Observable<boolean> {
    return this.loader.asObservable();
  }

  public async wrapPromise<T>(promise: () => Promise<T>): Promise<T | null> {
    this.showLoader();
    try {
      const result = await promise();
      return result;
    } catch (error) {
      console.error('Error in wrapped promise:', error);
      return null;
    } finally {
      this.hideLoader();
    }
  }

}
